import i18next from 'i18next';
import React from 'react'
import { useTranslation } from 'react-i18next';
import "./Nav.css";

const lngs = {
  jp: 'jp',
  en: 'en'
}
const Nav = () => {
  const { i18n } = useTranslation();
  return (
    <ul className="nav__container">
       <li className="nav__item"><a href="#stats">Research</a></li>
       <li className="nav__item"><a href="#why-us">Why Us</a></li>
       <li className="nav__item"><a href="#our-plan">Our Plan</a></li>
       <li className="nav__item"><a href="#faq">FAQ</a></li>
       <li className="nav__item"><a href="#contact">Contact</a></li> 
       <li>
        <button className='lang__switch' type='submit' 
          style={i18next.resolvedLanguage===lngs.jp ? {fontWeight: '700'} : {}}
          onClick={()=> i18n.changeLanguage(lngs.jp)}>
            JP 
        </button><span className='nav__switch__separator'>/</span>
        <button className='lang__switch' type='submit'
        style={i18next.resolvedLanguage===lngs.en ? {fontWeight: '700'} : {}}
          onClick={()=> i18n.changeLanguage(lngs.en)}>
          EN
        </button>
        </li>
    </ul>
  )
}

export default Nav